import { DocumentsSection } from "Components/AML/AMLUserDetail/shared/DocumentsSection";
import { VerificationsSection } from "Components/AML/AMLUserDetail/shared/VerificationsSection";
import { RegistryLinks } from "Components/Shared/RegistryLinks/RegistryLinks";
import { ValueItems } from "Components/Shared/ValuesBox/ValueItems";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import type { PartyDto, UserVerificationDto } from "Infrastructure/Api/Api";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";
import { getFormattedAddress } from "Utils/AddressUtils";
import { formatDate } from "Utils/DateUtils";
import { formatPhone } from "Utils/PhoneUtils";

type Props = {
  partyData: PartyDto;
  verificationData: UserVerificationDto;
};

export const SelfEmployedContent = ({ partyData, verificationData }: Props) => {
  const { t } = useResource();
  const { getCountryName } = useCountryNameResolver();

  const {
    type,
    addresses,
    companyName,
    companyNumber,
    phone,
    email,
    taxNumber,
    personalNumber,
    birthDate,
    birthPlace,
    nationality,
    gender,
    lastName,
    firstName,
  } = partyData;

  return (
    <>
      <ValuesBox title={t(Resources.AML.BasicInfo)}>
        <ValueItems
          values={[
            {
              label: t(Resources.Common.PartyTypeLabel),
              value: t(Resources.Form.PartyType[type]),
            },
            {
              label: t(Resources.AML.CompanyName),
              value: companyName || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.FirstName),
              value: firstName || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.LastName),
              value: lastName || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.CompanyNumber),
              value: companyNumber || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.TaxNumber),
              value: taxNumber || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.PersonalNumber),
              value: personalNumber || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.BirthDate),
              value: birthDate
                ? formatDate(birthDate)
                : t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.BirthPlace),
              value: birthPlace || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.Nationality),
              value: getCountryName(nationality) || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.Gender),
              value: gender
                ? t(Resources.Form.PersonalData.Sex[gender])
                : t(Resources.Common.Unknown),
            },
            ...addresses.map((address) => ({
              label: t(Resources.Form.AddressType[address.type]),
              value: getFormattedAddress(address),
            })),
            {
              label: t(Resources.AML.Phone),
              value: formatPhone(phone) || t(Resources.Common.Unknown),
            },
            {
              label: t(Resources.AML.Email),
              value: email || t(Resources.Common.Unknown),
            },
          ]}
        />
      </ValuesBox>
      {companyNumber && <RegistryLinks companyNumber={companyNumber} />}
      <DocumentsSection partyData={partyData} />
      <VerificationsSection
        verificationData={verificationData}
        partyType={type}
      />
    </>
  );
};
